import { render, staticRenderFns } from "./Colour.vue?vue&type=template&id=a9f63a18&scoped=true"
import script from "./Colour.vue?vue&type=script&lang=js"
export * from "./Colour.vue?vue&type=script&lang=js"
import style0 from "./Colour.vue?vue&type=style&index=0&id=a9f63a18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f63a18",
  null
  
)

export default component.exports